import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { finalize } from 'rxjs/operators';
import { b } from '@angular/core/src/render3';

@Component({
	selector: 'mark-quote-as-accepted',
	template: require('./mark-quote-as-accepted.modal.html'),
	styles: [require('./mark-quote-as-accepted.modal.scss')]
})
export class MarkQuoteAsAcceptedModal {
	@Input('jobId') jobId: number;
	@Input('quoteId') quoteId: number;
	@Input('autoGenerateInvoice') autoGenerateInvoice: boolean;
	@Output('updateQuoteEvent')
	updateQuoteEvent: EventEmitter<any> = new EventEmitter<any>();
	disableButtons = false;

	constructor(
		private quotesDataService: QuotesDataProvider,
		private messageService: MessageService
	) {}

	markQuoteAsAccepted(): void {
		this.disableButtons = true;
		this.quotesDataService
			.markQuoteAsAccepted(this.jobId, this.quoteId)
			.pipe(finalize((): boolean => (this.disableButtons = false)))
			.subscribe(
				(): void => this.successMarkAsAcceptedInvoice(),
				(error): void => this.messageService.handleError(error)
			);
	}

	successMarkAsAcceptedInvoice() {
		this.updateQuoteEvent.emit();
		this.messageService.showToaster('s_1', 'editQuote');
		$('#markQuoteAsAcceptedModal').modal('hide');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal.ts